// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7ea679b5","428":"8ffe699e"}[chunkId] + ".chunk.js";
};